// @ts-nocheck

import React, { memo, useMemo } from 'react';
import styled, { css } from 'styled-components';

import { BoomHalloweenIcon, BoomPatrickIcon, BoomValentineIcon } from '../../modules/boom/assets/svg';
import { BoomSkinIds, type BoomSkinId } from '../../modules/boom/types/global';
import {
  MenuDesktopArrowIcon,
  SportsMenuBtnContent,
  SportsMenuBtnLabel,
  SportsMenuListItem,
} from '../../styled-components/shared';
import Counter from '../Counter';

const StyledCounter = styled(Counter)`
  width: 1.6em;
  height: 1.6em;
  font-weight: bold;
  font-size: 94%;
`;

const SharedIconStyle = css`
  width: 1.6em;
  height: 1.6em;
  margin: 0.15em 0.5em;
  color: #fff;
`;

const StyledBoomHalloweenIcon = styled(BoomHalloweenIcon)`
  ${SharedIconStyle}
`;

const StyledBoomValentineIcon = styled(BoomValentineIcon)`
  ${SharedIconStyle}
`;

const StyledBoomPatrickIcon = styled(BoomPatrickIcon)`
  ${SharedIconStyle}
`;

type MenuDesktopBoomButtonProps = {
  nbBoomNotifications: number;
  openBoomView: () => void;
  skinId?: BoomSkinId;
};

const MenuDesktopBoomButton = ({
  nbBoomNotifications,
  openBoomView,
  skinId = BoomSkinIds.HALLOWEEN,
}: MenuDesktopBoomButtonProps) => {
  const MenuIcon = useMemo(() => {
    switch (skinId) {
      case BoomSkinIds.VALENTINE:
        return StyledBoomValentineIcon;
      case BoomSkinIds.PATRICK:
        return StyledBoomPatrickIcon;
      case BoomSkinIds.HALLOWEEN:
      default:
        return StyledBoomHalloweenIcon;
    }
  }, [skinId]);

  return (
    <SportsMenuListItem onClick={openBoomView}>
      <SportsMenuBtnContent>
        <MenuIcon />
        <SportsMenuBtnLabel $separator>
          Boom
          {nbBoomNotifications ? <StyledCounter counter={nbBoomNotifications} /> : null}
        </SportsMenuBtnLabel>
      </SportsMenuBtnContent>
      <MenuDesktopArrowIcon className="see-all-btn" />
    </SportsMenuListItem>
  );
};

export default memo<MenuDesktopBoomButtonProps>(MenuDesktopBoomButton);
